import { useNavigate } from "react-router-dom";

import * as Material from "@mui/material";

import "./index.scss";

import { Button } from "@fragments";

import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { SlowMotionVideoRounded } from "@mui/icons-material";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import KeyboardDoubleArrowRightRoundedIcon from '@mui/icons-material/KeyboardDoubleArrowRightRounded';


export default function CoursesBar({ info, handleCreateNew }) {
    const navigate = useNavigate();

    function Course({ data }) {
        return (
            <div
                className="course-item"
                onClick={() => {
                    navigate("section/" + data.id);
                }}
            >
                <div className="banner-container bsf-9">
                    <img src={data.banner?.condensed} className="banner" />
                </div>

                <img src={data.banner?.condensed} className="banner-effect-on-hover" />

                <div className="info mt-2">
                    <div className="title-container csf-2">
                        <KeyboardDoubleArrowRightRoundedIcon className="arrow-icon" />
                        <h4 className="bold">{data.name}</h4>
                    </div>
                    <span className="description csf-6" numberOfLines={2}>
                        {data.description?.text}
                    </span>
                </div>
            </div>
        );
    }

    return (
        <div className="courses-section pt-1 pb-2">
            <div className="header py-1 csf-2 screen-padding">
                <SlowMotionVideoRounded className="section-icon" />
                <h3 className="bold">Sessões de conteúdo</h3>

                {info.isAdmin() && (
                    <Button
                        tooltip="Adicionar curso"
                        onClick={handleCreateNew}
                        icon={<AddRoundedIcon />}
                        color="overlay"
                    />
                )}
            </div>

            {
                info?.courses && <div className="courses-list">
                    <div className="carousel-wrapper">
                        <Carousel
                            responsive={{
                                universal: {
                                    breakpoint: { max: 4000, min: 601 },
                                    items: 3,
                                    slidesToSlide: 2,
                                },
                                mobile: {
                                    breakpoint: { max: 600, min: 0 },
                                    items: 2,
                                    slidesToSlide: 1,
                                },
                            }}
                            infinite={false}
                            draggable={false}
                            swipeable={false}
                            keyBoardControl={true}
                            containerClass="courses-list mt-1"
                            itemClass="course-carousel-item"
                            partialVisible={false}
                            centerMode={false}
                        >
                            {info?.courses?.map((course, index) => (
                                <div key={index} className={`${index === 0 ? 'pl-5' : ''}`}>
                                    <Course data={course} />
                                </div>
                            ))}
                        </Carousel>
                    </div>
                </div>
            }
        </div>
    );
}